import { render, staticRenderFns } from "./Template3.vue?vue&type=template&id=39b0e6c3&scoped=true&"
import script from "./Template3.vue?vue&type=script&lang=js&"
export * from "./Template3.vue?vue&type=script&lang=js&"
import style0 from "./Template3.vue?vue&type=style&index=0&id=39b0e6c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b0e6c3",
  null
  
)

export default component.exports